import { render, staticRenderFns } from "./Plan.vue?vue&type=template&id=1619b062&scoped=true"
import script from "./Plan.vue?vue&type=script&lang=js"
export * from "./Plan.vue?vue&type=script&lang=js"
import style0 from "./Plan.vue?vue&type=style&index=0&id=1619b062&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1619b062",
  null
  
)

export default component.exports